/* eslint-disable class-methods-use-this */
import { CreateWorkStation, TenantProfileWorkStation } from '@models';
import { EntityDto, PagedResultDto } from 'services/dto';
import http from '../httpService';
import {
  AvailableStationInput,
  PagedTenantProfileResultRequestDto,
  PagedTenantProfileWorkStations,
  ProfileLogoInput,
  TenantProfile,
  UpdateTenantProfile,
  UpdateTenantProfileVatNumber,
} from './dto/tenantProfile';
import { DemoMode, SetDemoModeInput } from './dto/demoMode';

class TenantProfileService {
  public async get(entityDto: EntityDto): Promise<TenantProfile> {
    const result = await http.get('api/services/app/TenantProfile/GetProfile', {
      params: entityDto,
    });
    return result.data.result;
  }
  public async update(input: UpdateTenantProfile) {
    const result = await http.put('api/services/app/TenantProfile/Update', input);
    return result.data.result;
  }

  public async updateLogo(input: ProfileLogoInput) {
    const result = await http.put('api/services/app/TenantProfile/UpdateLogo', input);
    return result.data.result;
  }

  public async deleteLogo() {
    await http.delete('api/services/app/TenantProfile/DeleteLogo');
  }

  public async updateVatNumber(input: UpdateTenantProfileVatNumber) {
    const result = await http.put('api/services/app/TenantProfile/UpdateVatNumber', input);
    return result.data.result;
  }

  public async getAll(
    pagedFilterAndSortedRequest: PagedTenantProfileResultRequestDto
  ): Promise<PagedResultDto<TenantProfile>> {
    const result = await http.get('api/services/app/TenantProfile/GetAll', {
      params: pagedFilterAndSortedRequest,
    });
    return result.data.result;
  }

  public async getAllWorkStations(
    input: PagedTenantProfileWorkStations
  ): Promise<PagedResultDto<TenantProfileWorkStation>> {
    const result = await http.get('api/services/app/TenantProfileWorkStation/GetAll', {
      params: input,
    });
    return result.data.result;
  }

  public async getAvailableWorkStations(
    input: AvailableStationInput
  ): Promise<TenantProfileWorkStation[]> {
    const result = await http.get('api/services/app/TenantProfileWorkStation/GetAllAvailable', {
      params: input,
    });
    return result.data.result;
  }

  public async getWorkStationInUse(
    input: AvailableStationInput
  ): Promise<TenantProfileWorkStation> {
    const result = await http.get('api/services/app/TenantProfileWorkStation/GetWorkStationInUse', {
      params: input,
    });
    return result.data.result;
  }

  public async onlineBookingChange() {
    const result = await http.post(`api/services/app/TenantProfile/ChangeOnlineBooking`);
    return result.data.result;
  }

  public async changeActive(id: number) {
    const result = await http.post(`api/services/app/Tenant/ChangeActive?id=${id}`);
    return result.data.result;
  }

  public async getDemoMode(tenantId: number): Promise<DemoMode> {
    const result = await http.get('api/services/app/Tenant/GetDemoMode', {
      params: { tenantId },
    });
    return result.data.result;
  }

  public async setDemoMode(input: SetDemoModeInput): Promise<DemoMode> {
    const result = await http.post('api/services/app/Tenant/SetDemoMode', input);
    return result.data.result;
  }

  public async deleteDropOffSchedule(entityDto: EntityDto<string>) {
    const result = await http.delete('api/services/app/TenantProfileDropOffSchedule/Delete', {
      params: entityDto,
    });
    return result.data;
  }

  public async deleteWorkStation(entityDto: EntityDto<string>) {
    const result = await http.delete('api/services/app/TenantProfileWorkStation/Delete', {
      params: entityDto,
    });
    return result.data;
  }

  public async deleteWorkSchedule(entityDto: EntityDto<string>) {
    const result = await http.delete('api/services/app/TenantProfileWorkSchedule/Delete', {
      params: entityDto,
    });
    return result.data;
  }

  public async updateWorkStation(workStation: TenantProfileWorkStation) {
    const result = await http.put('api/services/app/TenantProfileWorkStation/Update', workStation);
    return result.data.result;
  }

  public async createWorkStation(
    workStation: CreateWorkStation
  ): Promise<TenantProfileWorkStation> {
    const result = await http.post('api/services/app/TenantProfileWorkStation/Create', workStation);
    return result.data.result;
  }
}

export default new TenantProfileService();
